/**
 * MEC Calendar - Remove Select2 from Custom Search Filters
 *
 * MEC initializes Select2 on all its select elements. This script destroys
 * Select2 on our custom horizontal search form so our native select styling works.
 */

function mecDestroySelect2InCustomForm() {
    const form = document.querySelector('.mec-custom-horizontal-search .mec-horizontal-search-form');
    if (!form) return;

    // Find every select inside our form that Select2 has touched
    form.querySelectorAll('select.select2-hidden-accessible').forEach(function(select) {
        if (typeof jQuery !== 'undefined' && jQuery(select).data('select2')) {
            try {
                jQuery(select).select2('destroy');
            } catch (e) {
                // Already destroyed or not initialized — safe to ignore
            }
        }
        // Force the native select visible regardless
        select.style.display = '';
        select.removeAttribute('tabindex');
        select.removeAttribute('aria-hidden');
        select.classList.remove('select2-hidden-accessible');
    });

    // Remove any orphaned Select2 container spans left behind
    form.querySelectorAll('.select2-container').forEach(function(el) {
        el.remove();
    });
}

// Run after DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    // First pass — after MEC's own DOMContentLoaded handlers
    setTimeout(mecDestroySelect2InCustomForm, 300);

    // Second pass — MEC may re-init Select2 in a later setTimeout
    setTimeout(mecDestroySelect2InCustomForm, 800);

    // MutationObserver as a catch-all for any further re-initialization
    const form = document.querySelector('.mec-custom-horizontal-search .mec-horizontal-search-form');
    if (!form) return;

    const observer = new MutationObserver(function(mutations) {
        let needsCleanup = false;
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1 && (
                    node.classList.contains('select2-container') ||
                    node.querySelector('.select2-container')
                )) {
                    needsCleanup = true;
                }
            });
        });
        if (needsCleanup) mecDestroySelect2InCustomForm();
    });

    observer.observe(form, { childList: true, subtree: true });
});
